import React, { useState, useEffect, createContext } from 'react';
import './App.css';
import { makeStyles, Button, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { Amplify, API, graphqlOperation } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsconfig from './aws-exports';
import { BrowserRouter as Router } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import AdminRoutes from './components/AdminRoutes';
import { getUser } from './graphql/queries';

export const UserContext = createContext();
Amplify.configure(awsconfig);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toggleSidebarButton: {
    zIndex: 10000,
  },
}));

export default function App() {
  const classes = useStyles();
  const [currentUser, setCurrentUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);

  useEffect(() => {
    if (currentUser) {
      API.graphql(graphqlOperation(getUser, { id: currentUser.attributes.sub }))
        .then(response => {
          const fetchedUserType = response.data.getUser.userType;
          setUserType(fetchedUserType);
          if (fetchedUserType === 'ACECURA_ADMIN') {
            setIsAuthorized(true);
          } else {
            setIsAuthorized(false);
          }
        })
        .catch(error => {
          console.error('Error fetching user:', error);
        });
    }
  }, [currentUser]);

  return (
    <Authenticator>
      {({ signOut, user }) => {
        setCurrentUser(user);

//console.log(user);

        return (
          <UserContext.Provider value={currentUser?.attributes?.sub}>
            {isAuthorized ? (
              <Router>
                <main className={classes.root}>
                {showSidebar && <Sidebar />}

                  <div className={classes.content}>
                    <IconButton
                      className={classes.toggleSidebarButton}
                      onClick={() => setShowSidebar(!showSidebar)}
                      color="primary"
                    >
                      <MenuIcon />
                    </IconButton>
                    

                    <h3>Hello {user.attributes?.email}</h3>

                    <AdminRoutes />
                    <div className="divider"></div>
                  </div>
                </main>
              </Router>
            ) : (
              <div>
                You do not have permission to access this application.
                <button onClick={signOut}>Sign Out</button>
              </div>
            )}
          </UserContext.Provider>
        );
      }}
    </Authenticator>
  );
}
